var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ 'dropdown', _vm.showContent ? 'dropdown--open' : '' ]},[_c('div',{class:[
    'dropdown__title',
    _vm.isDisabled ? 'dropdown__title--disabled' : '',
    _vm.isAutonomous ? 'dropdown__title--clickable' : '',
    _vm.isSpaced ? 'dropdown__title--sbetween' : ''
    ],on:{"click":() => _vm.toggleContent()}},[_vm._t("title")],2),_c('div',{ref:"content",staticClass:"dropdown__content"},[(_vm.showContent)?_vm._t("content"):_vm._t("loader")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }